import * as React from "react";
import "../scss/styles.scss";
import "font-awesome/css/font-awesome.min.css";
import { useDispatch, useSelector } from "react-redux";
import { useMountEffect } from "../hooks/useMountEffect";
import { fetchData } from "../store/action-creators/DataActionCreators";
import { silentLogin } from "../store/action-creators/UserActionCreators";
import { ThunkDispatcher } from "../store/actions/All";
import { selectAnnouncements, selectHasLoaded } from "../store/selectors/DataSelectors";
import AnnouncementPanel from "./Ui/AnnouncementPanel";
import Col from "./Common/Col";
import Grid from "./Common/Grid";
import Row from "./Common/Row";
import NavMenu from "./NavMenu";
import Router from "../router";
import { fetchParameters } from "../store/action-creators/parameters";
import LoadingIndicator from "./Feedback/LoadingIndicator";

const App = () => {
  useMountEffect(() => {
    dispatch(silentLogin);
    dispatch(fetchParameters());
    dispatch(fetchData);
  });

  const dispatch: ThunkDispatcher = useDispatch();

  const hasLoaded = useSelector(selectHasLoaded);

  const announcements = useSelector(selectAnnouncements);

  return <>
    <div className="app__navcontainer">
      <NavMenu />
      <Grid className="container app__container" fluid>
        <div className="app__wrap">
          {hasLoaded ? (
            <>
              <div className="margin-bottom-sm">
                {
                  announcements.map((a, i) => (
                    <Row key={i}>
                      <Col xs={12}>
                        <AnnouncementPanel announcement={a} />
                      </Col>
                    </Row>
                  ))
                }
              </div>
              <Router />
            </>
          ) : (
            <LoadingIndicator />
          )}
        </div>
      </Grid>
    </div>
  </>;
};

export default App;
